import { CountryFlag } from "@/components/CountryFlag";
import { cn } from "@/lib/utils";

export const CountryLabel = ({
  code,
  name,
  size = 18,
  className,
  textClassName,
  flagClassName,
  dataTestId,
  flagTestId,
}) => {
  return (
    <span className={cn("inline-flex items-center gap-2 align-middle", className)} data-testid={dataTestId}>
      <CountryFlag code={code} name={name} size={size} className={flagClassName} dataTestId={flagTestId} />
      <span className={cn("leading-none", textClassName)}>{name}</span>
    </span>
  );
};